class Listing {
    constructor(listing) {
        this.blogs = [...listing.querySelector('.js-listings__grid').children]
        this.moreBtn = listing.querySelector('.js-listings__more-btn')
        this.filterBtn = listing.querySelector('.js-listings__filter-btn')
        this.filterOptions = listing.querySelector('.js-listings__filter-options')
        this.filterIcons = listing.querySelectorAll('.js-listings__filter-icon')
        this.tags = listing.querySelectorAll('.js-blog-teaser__category, .js-blog-teaser__topic')
        this.initialTeaserAmount = listing.dataset.initialAmount ? parseInt(listing.dataset.initialAmount) : 12
        this.amountOfVisibleBlogs = 0
        this.filter = false
        this.allTopics = this.getAllTopics()

        if (this.filterBtn) {
            this.initFilterBtn()
            this.initFilterOptions()
            this.initTags()
        }
        this.initMoreBtn()
    }

    setNewFilter(newFilter) {
        this.filter = newFilter
        this.changeFilterBtnText()
        this.amountOfVisibleBlogs = this.initialTeaserAmount
        this.updateMoreBtn()
        this.updateBlogs()
    }

    initTags() {
        const topics = this.allTopics.map((topic) => topic.title)
        this.tags.forEach((tag) => {
            tag.addEventListener('click', () => {
                if (topics.includes(tag.textContent)) {
                    this.setNewFilter(tag.textContent)
                } else {
                    this.setNewFilter(false)
                }
            })
        })
    }

    initFilterBtn() {
        this.changeFilterBtnText()
        document.addEventListener('click', (event) => {
            if (event.target === this.filterBtn) {
                this.filterOptions.classList.toggle('listings__filter-options--active')
                this.filterIcons[0].classList.toggle('listings__filter-icon--active')
                this.filterIcons[1].classList.toggle('listings__filter-icon--active')
            } else {
                this.filterOptions.classList.remove('listings__filter-options--active')
                this.filterIcons[0].classList.add('listings__filter-icon--active')
                this.filterIcons[1].classList.remove('listings__filter-icon--active')
            }
        })
    }

    initFilterOptions() {
        this.filterOptions.innerHTML = ''
        this.createFilterOption('All', this.blogs.length)
        Object.keys(this.allTopics).forEach((topic) => {
            const title = this.allTopics[topic].title
            const amount = this.allTopics[topic].amount
            this.createFilterOption(title, amount)
        })
    }

    initMoreBtn() {
        this.onMoreBtnClick()
        this.moreBtn.addEventListener('click', (event) => this.onMoreBtnClick())
    }

    changeFilterBtnText() {
        const title = this.getCurrentTopic().title
        const amount = this.getCurrentTopic().amount
        this.filterBtn.firstChild.innerHTML = `${title} (${amount})`
    }

    createFilterOption(text, amount) {
        let btn = document.createElement('div')
        btn.innerHTML = `${text} <span>(${amount})</span>`
        btn.addEventListener('click', (event) => {
            if (text === 'All') {
                this.setNewFilter(false)
            } else {
                this.setNewFilter(text)
            }
        })
        this.filterOptions.appendChild(btn)
    }

    getAllTopics() {
        const arrayOfAllTopics = this.blogs.reduce((allTopicsArray, blog) => {
            const elementTopics = this.getTopicsOfElement(blog)
            return [...allTopicsArray, ...elementTopics]
        }, [])

        const setOfAllTopics = new Set(arrayOfAllTopics)
        setOfAllTopics.delete('')
        return [...setOfAllTopics].map((title) => ({
            title,
            amount: arrayOfAllTopics.filter((topic) => topic === title).length,
        }))
    }

    getCurrentTopic() {
        return (
            this.allTopics.filter((topic) => topic.title === this.filter)[0] || {
                title: 'All',
                amount: this.blogs.length,
            }
        )
    }

    getTopicsOfElement(element) {
        const topicsString = element.dataset.topics
        return topicsString.split(';')
    }

    onMoreBtnClick() {
        this.amountOfVisibleBlogs += this.initialTeaserAmount
        this.updateMoreBtn()
        this.updateBlogs()
    }

    updateMoreBtn() {
        const currentMax = this.getCurrentTopic().amount
        this.moreBtn.classList.toggle('listings__hidden', this.amountOfVisibleBlogs >= currentMax)
    }

    updateBlogs() {
        let amountOfValidBlogs = 0

        this.blogs.forEach((blog, index) => {
            const elementTopics = this.getTopicsOfElement(blog)
            const indexValid = amountOfValidBlogs < this.amountOfVisibleBlogs
            const filterValid = elementTopics.includes(this.filter) || !this.filter

            if (indexValid && filterValid) {
                blog.classList.remove('listings__hidden')
                amountOfValidBlogs += 1
            } else {
                blog.classList.add('listings__hidden')
            }
        })
    }
}

function initListings() {
    this.backend = document.querySelectorAll('.neos-backend')
    if (this.backend.length) return

    const listings = document.querySelectorAll('.js-listings')
    listings.forEach((listing) => new Listing(listing))
}

if (document.readyState !== 'loading') {
    initListings()
} else {
    initListings()
}
